import React, { useState, useEffect } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const ClosedBanner = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if the banner should be shown
    // Closed from February 26, 2026 – reopen 1. mai 2026
    const closureEndDate = new Date('2026-04-30T23:59:59');
    const now = new Date();
    
    // Show banner only if we're before 1. mai 2026
    if (now < closureEndDate && !isDismissed) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [isDismissed]);

  if (!isVisible) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black/60 z-[100] backdrop-blur-sm"
        onClick={handleDismiss}
      />
      
      {/* Popup */}
      <div 
        data-testid="closed-banner-popup"
        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[101] w-[90%] max-w-md bg-white rounded-2xl shadow-2xl p-8 animate-in fade-in zoom-in duration-300"
      >
        {/* Close button */}
        <button 
          onClick={handleDismiss}
          data-testid="closed-banner-close-btn"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-amber-600" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center">
          <h2 className="font-heading text-2xl text-gray-900 mb-4">
            {language === 'no' ? 'Midlertidig stengt' : 'Temporarily Closed'}
          </h2>
          
          <p className="text-gray-600 leading-relaxed mb-6">
            {language === 'no' 
              ? 'På grunn av nødvendig vedlikehold holder vi midlertidig stengt fra 26. februar til 30. april.'
              : 'Due to necessary maintenance, we are temporarily closed from February 26th until April 30th.'
            }
          </p>

          <div className="bg-gray-100 rounded-xl p-4 mb-6">
            <p className="text-sm text-gray-500 mb-1">
              {language === 'no' ? 'Vi åpner igjen' : 'We reopen'}
            </p>
            <p className="font-semibold text-gray-900 text-lg">
              {language === 'no' ? '1. mai 2026' : 'May 1st, 2026'}
            </p>
          </div>

          <button
            onClick={handleDismiss}
            data-testid="closed-banner-ok-btn"
            className="btn-primary w-full"
          >
            {language === 'no' ? 'Jeg forstår' : 'I understand'}
          </button>
        </div>
      </div>
    </>
  );
};
